import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Bell, ArrowRight, Camera, Sparkles } from "lucide-react";
import api from "../../lib/api";

const HERO = "/lifestyle/lifestyle_hero.png";

export default function AppHome() {
  const [products, setProducts] = useState([]);
  useEffect(() => {
    api.get("/products").then((r) => setProducts(r.data || []));
  }, []);
  const featured = products.filter((p) => !p.is_legacy).slice(0, 4);

  return (
    <div data-testid="app-home" className="pb-6">
      <header className="flex items-center justify-between px-5 pt-12 pb-3">
        <div className="font-serif text-2xl tracking-luxury text-poche-gold">POCHE</div>
        <button className="relative text-white/85" aria-label="Notifications">
          <Bell size={20} strokeWidth={1.4} />
          <span className="absolute -top-1 -right-1 w-2 h-2 bg-poche-gold rounded-full" />
        </button>
      </header>

      {/* Hero */}
      <div className="relative mx-4 mt-2 aspect-[3/4] overflow-hidden">
        <img src={HERO} alt="" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/95 via-black/45 to-transparent" />
        <div className="absolute bottom-0 left-0 right-0 p-6">
          <p className="text-[10px] tracking-luxury uppercase text-poche-gold">Atelier 2026</p>
          <h1 className="font-serif text-4xl leading-[0.95] mt-2">Built For<br /><span className="italic text-poche-gold">Real Faces.</span></h1>
          <Link to="/app/shop" data-testid="app-hero-shop" className="btn-gold mt-5 !py-3 !px-5 text-[10px]">Shop Collection <ArrowRight size={12} /></Link>
        </div>
      </div>

      {/* CTAs */}
      <div className="grid grid-cols-2 gap-3 mx-4 mt-4">
        <Link to="/app/try-on" data-testid="app-tryon-cta" className="bg-poche-ink border border-poche-gold/30 p-4">
          <Camera size={18} className="text-poche-gold" strokeWidth={1.4} />
          <div className="font-serif text-lg mt-3">Virtual Try-On</div>
          <div className="text-[10px] text-white/55 tracking-wider mt-1">See it on you.</div>
        </Link>
        <Link to="/app/fit-profile" data-testid="app-fitprofile-cta" className="bg-poche-ink border border-poche-gold/30 p-4">
          <Sparkles size={18} className="text-poche-gold" strokeWidth={1.4} />
          <div className="font-serif text-lg mt-3">My Fit Profile</div>
          <div className="text-[10px] text-white/55 tracking-wider mt-1">Scan & match.</div>
        </Link>
      </div>

      {/* Drop banner */}
      <div className="mx-4 mt-5 bg-poche-gold text-poche-black p-4 flex items-center gap-3">
        <div className="dot-pulse" style={{ background: "#0A0A0A" }} />
        <div className="flex-1">
          <div className="text-[10px] tracking-luxury uppercase">VIP Drop · Live in 3 hours</div>
          <div className="font-serif text-lg mt-0.5">The Legacy 02/25 unlocks.</div>
        </div>
        <ArrowRight size={16} />
      </div>

      {/* Featured */}
      <div className="px-5 mt-7">
        <div className="flex items-center justify-between">
          <h2 className="font-serif text-2xl">Explore</h2>
          <Link to="/app/shop" className="text-[10px] tracking-luxury uppercase text-poche-gold">View all →</Link>
        </div>
        <div className="grid grid-cols-2 gap-3 mt-4">
          {featured.map((p) => (
            <Link key={p.product_id} to={`/app/product/${p.product_id}`} data-testid={`app-card-${p.product_id}`}>
              <div className="bg-poche-ivory aspect-square overflow-hidden">
                <img src={p.images[0]} alt={p.name} className="w-full h-full object-cover" />
              </div>
              <div className="mt-2">
                <div className="text-[10px] tracking-luxury uppercase text-white/55">{p.name}</div>
                <div className="font-serif text-base">{p.subtitle}</div>
                <div className="text-poche-gold text-sm">${p.price.toLocaleString()}</div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
